import React from 'react';
import { alpha, styled } from '@mui/material/styles';
import Slider from '@mui/material/Slider';
import { Colors } from 'modules/theme';
import PropTypes from 'prop-types';
import { Icon } from 'modules/ui';
import styles from './ImageZoomSlider.module.scss';

const PREFIX = 'ImageZoomSlider';

const classes = {
  root: `${PREFIX}-root`,
  thumb: `${PREFIX}-thumb`,
  track: `${PREFIX}-track`,
  trackAfter: `${PREFIX}-trackAfter`,
};

const Root = styled('div')(() => ({
  [`& .${classes.root}`]: {
    margin: 20,
    marginLeft: 10,
    marginRight: 10,
    width: 127,
  },
  [`& .${classes.thumb}`]: {
    backgroundColor: ACTIVE_BACKGROUND,
    '&$focused, &$activated, &$jumped, &:hover': {
      boxShadow: `0px 0px 0px 4px ${alpha(ACTIVE_BACKGROUND, 0.16)}`,
    },
  },
  [`& .${classes.track}`]: {
    backgroundColor: ACTIVE_BACKGROUND,
    height: 2,
    borderRadius: 4,
  },
  [`& .${classes.trackAfter}`]: {
    backgroundColor: INACTIVE_BACKGROUND,
    borderRadius: 4,
  },
}));

const ACTIVE_BACKGROUND = Colors.darkBlue;
const INACTIVE_BACKGROUND = Colors.grayishBlue;

const StyledZoomSlider = Slider;

function ImageZoomSlider({ onChange, ...otherProps }) {
  return (
    <Root className={styles.sliderContainer}>
      <Icon name="image" size={14} color={Colors.grayishBlue} />
      <StyledZoomSlider step={0.01} onChange={onChange} {...otherProps} />
      <Icon name="image" size={21} color={Colors.grayishBlue} />
    </Root>
  );
}

ImageZoomSlider.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
};

export default ImageZoomSlider;
